import './DiagnosticStyles.css';
import React, {useState, useContext, useEffect} from 'react';
import {Form, Select, Row, Col, Tooltip, Switch, Radio, Divider, Checkbox, TreeSelect, Space} from 'antd';
import {BrandContext} from "../common/BrandContext";
import {UserContext} from "../common/UserContext";
import HelpIcon from "@mui/icons-material/Help";
import GroupByAggregateView from './GroupByAggregateView';
import axios from "../common/axios";
import {GRID_ENUMS, AGGREGATE_LEVELS, FB_MESSAGES, COMPARISON_TYPE, GridStyle} from "./Styles";
import ComparisonView from "./ComparisonView";
import TreeSelectFilter from "./TreeSelectFilter";
import StudentTestResultDialog from "./StudentTestResultDialog";
import CircularLoader from "../common/CircularLoader";
import ClassQuestionViewDiagnostic from "./ClassQuestionViewDiagnostic";
import Button from "../common/Button";

const { Option } = Select;

const DiagnosticReports = () => {
    const REPORTS = {
            CLASS_QUESTION_VIEW: {val: 1, description: 'Results by question'},
            ORDER_BY_AGGREGATE_VIEW: {val: 2, description: 'Results by skill'},
            // COMPARISON_VIEW: {val: 3, description: 'Comparison View'}
            COMPARISON_VIEW: {val: 3, description: 'Test comparison'}
        },
        TEST_TYPES = {
            DIAGNOSTIC_PRE_TEST: {code: 'PRE_TEST', description: 'pre-test'},
            DIAGNOSTIC_POST_TEST: {code: 'POST_TEST', description: 'post-test'}
        },
        AGGREGATE_VIEW_TOOLTIP = (
            <div><p>This will allow you to see student performance at various textbook/curriculum levels.</p>
                {/*<p>Use the column toggle buttons to collapse the view.</p>*/}
            </div>),
        COMPARISON_VIEW_TOOLTIP = (<div><p>This will filter results by textbook/curriculum levels.</p></div>);

    const brandConfig = useContext(BrandContext),
        {user, setUser, menuPosition} = useContext(UserContext),
        [isLoading, setLoading] = useState(false),
        [isMainLoading, setIsMainLoading] = useState(true),
        [feedbackMessage, setFeedbackMessage] = useState(undefined),
        [warningFeedbackMessage, setWarningFeedbackMessage] = useState(undefined),
        [students, setStudents] = useState([]),
        [studentIds, setStudentIds] = useState([]),
        [initialStudentIds, setInitialStudentIds] = useState([]),
        [classId, setClassId] = useState(user.classId),
        [className, setClassName] = useState(user.classId?user.classes[user.classId]:null),
        [diagnosticForm] = Form.useForm(),
        [selectedTestTypeVal,setSelectedTestTypeVal] = useState(REPORTS.CLASS_QUESTION_VIEW.val),
        [selectedTestTempTypeVal,setSelectedTestTempTypeVal] = useState(REPORTS.CLASS_QUESTION_VIEW.val),
        [reportTitle,setReportTitle] = useState(''),
        [contentType, setContentType] =  useState(GRID_ENUMS.TEXT),
        [comparisonContentTypeVal, setComparisonContentTypeVal] =  useState(COMPARISON_TYPE.TEXT.val),
        [selectedAggregateLevel,setSelectedAggregateLevel] = useState(AGGREGATE_LEVELS.SKILL),
        [studentColOrder,setStudentColOrder] = useState(GRID_ENUMS.NAME_ASC),
        [aggregateDisabled,setAggregateDisabled] = useState(true),
        [classDiagnosticForm] = Form.useForm(),
        [classDiagnosticFilterForm] = Form.useForm(),
        [topicId, setTopicId] = useState(user.topicId),
        [diagnosticTests,setDiagnosticTests] = useState([]),
        [selectedTestTypes,setSelectedTestTypes] = useState([]),
        [topics, setTopics] = useState([]),
        [syllabuses, setSyllabuses] = useState([]),
        [syllabusesMap, setSyllabusesMap] = useState({}),
        [textSyllabus,setTextSyllabus] = useState({}),
        [headerHeightOffset,setHeaderHeightOffset] = useState(0),
        [currentGraphRowHeight,setCurrentGraphRowHeight] = useState(0),
        [curriculumSyllabus, setCurriculumSyllabus] = useState({}),
        [selectedDifficultyIds,setSelectedDifficultyIds] = useState([]),
        [syllabusLabel,setSyllabusLabel] = useState(brandConfig.syllabusName),
        [topicLabel,setTopicLabel] = useState(brandConfig.topicName),
        [syllabusId, setSyllabusId] = useState(user.syllabusId),
        [selectedTestIds,setSelectedTestIds] = useState([]),
        [enabledStudentIdsMap,setEnabledStudentIdsMap] = useState({}),
        [enabledStudentIdsArr,setEnabledStudentIdsArr] = useState([]),
        [showTrendLines,setShowTrendLines] = useState(true),
        [showAverageLine,setShowAverageLine] = useState(true),
        [curriculumDisabled,setCurriculumDisabled] = useState(false),
        [tempTestIds,setTempTestIds] = useState([]),
        [curriculumValues, setCurriculumValues] = useState([]),
        [textValues, setTextValues] = useState([]),
        [studentId, setStudentId] = useState(),
        [triggerGenerate, setTriggerGenerate] = useState(null),
        [studentTestResultDialogOpen, setStudentTestResultDialogOpen] = useState(false),
        [questionCount, setQuestionCount] = useState(0),
        [testAssignmentsData, setTestAssignmentsData] = useState([]),
        [studentTestAssignmentsMap, setStudentTestAssignmentsMap] = useState({}),
        [reportGenerated, setReportGenerated] = useState(false),
        [hasStudentResults, setHasStudentResults] = useState(false),
        [testAssignmentIds, setTestAssignmentIds] = useState([]);

    const handleCloseStudentTestsDialog = (ref) => {
        setStudentTestResultDialogOpen(false);
        setStudentId(null);
    }

    const openStudentTestsDialog = (studentId) => {
        if (!studentId ) {
            return;
        }

        let locTestAssignmentIds = [];
        if (studentTestAssignmentsMap[studentId]) {
            for (const [testId, testAssignmentId] of Object.entries(studentTestAssignmentsMap[studentId])) {
                locTestAssignmentIds.push(testAssignmentId);
            }
        }
        setTestAssignmentIds(locTestAssignmentIds);
        setStudentId(studentId);
        setStudentTestResultDialogOpen(true);
    }

    const handleClassSelect = (classId) => {
        setClassId(classId);
        setClassName(user.classes[classId]);
        setSelectedTestIds([]);
        setFeedbackMessage(undefined);
        setWarningFeedbackMessage(undefined);
    }

    useEffect(()=>{
        if (classId) {
            axios.get('/web/ui/sc/studentsInClass',{params: {classId: classId}})
                .then(response => {
                    if(response.data){
                        const students = response.data;
                        setStudents(students);
                        const ids = [];
                        students.map(student=>{
                            ids.push(student.userId);
                        });
                        setStudentIds(ids);
                        setInitialStudentIds(ids);
                        diagnosticForm.setFieldsValue({['studentIds']:ids});
                        if(students.length === 0){
                            setFeedbackMessage(FB_MESSAGES.NO_STUDENTS_IN_CLASS);
                            setWarningFeedbackMessage(undefined);
                        } else {
                            showCascadingFeedbackMessage();
                        }
                    }
                }).catch(error => {
                console.error('Error loading students. ', error);
            });
        } else {
            showCascadingFeedbackMessage();
        }
    }, [classId]);

    useEffect(() => {
        if (students.length > 0 && tempTestIds.length > 0) {
            setSelectedTestIds(tempTestIds);
            showCascadingFeedbackMessage();
        }
    }, [students, studentIds]);

    useEffect(() => {
        showCascadingFeedbackMessage();
    }, [testAssignmentsData]);

    useEffect(() => {
        if (syllabuses.length === 0) {
            return;
        }
        let map = {};
        syllabuses.forEach(syllabus => {
            map[syllabus.syllabusId] = syllabus;
            if (syllabus.syllabusId === syllabusId) {
                setTextSyllabus(syllabus);
            }
        });
        setSyllabusesMap(map);

    },[syllabuses]);

    useEffect(()=>{
        const disabled = Object.keys(curriculumSyllabus).length === 0;
        setCurriculumDisabled(disabled);
        if(disabled){
            diagnosticForm.setFieldsValue({['comparisonContent']:COMPARISON_TYPE.TEXT});
        }

    },[curriculumSyllabus]);

    const clearStudentSelect = ()=>{
        diagnosticForm.setFieldsValue({['studentIds']:[]});
        setStudentIds([]);
    }

    const handleClassClear = ()=>{
        clearStudentSelect();
        setClassId(undefined);
        setStudents([]);
        setInitialStudentIds([]);
        setSelectedTestIds([]);
        setFeedbackMessage(undefined);
        setWarningFeedbackMessage(undefined);
    }

    const handleStudentChange = value=>{
        setStudentIds(value);
    }

    const handleSelectAllChange = event =>{
        if(event.target.checked){
            if(enabledStudentIdsArr.length > 0){
                setStudentIds(enabledStudentIdsArr);
                diagnosticForm.setFieldsValue({['studentIds']:enabledStudentIdsArr});
            }else{
                setStudentIds(initialStudentIds);
                diagnosticForm.setFieldsValue({['studentIds']:initialStudentIds});
            }
        }else{
            clearStudentSelect();
        }
    }

    const handleAggregateLevelChange = value =>{
        if(topicId && classId && Object.keys(studentTestAssignmentsMap).length > 0){
            //setLoading(true);
        }else{
            showCascadingFeedbackMessage();
        }
        setSelectedAggregateLevel(value);
    }

    const handleContentTypeChange = e =>{
        if(topicId && classId && Object.keys(studentTestAssignmentsMap).length > 0){
            // setLoading(true);
        }else{
            showCascadingFeedbackMessage();
        }
        setContentType(e.target.value);
    }
    const handleDifficultyChange = value =>{
        // setLoading(true);
        setSelectedDifficultyIds(value.sort());
    }

    const handleStudentColOrderByChange = value =>{
        // setLoading(true);
        setStudentColOrder(value);
    }

    // const toggleAggregate = stateVal =>{
    //     setAggregateDisabled(!stateVal);
    //     if(aggregateDisabled){
    //         setSelectedTestTypeVal(REPORTS.ORDER_BY_AGGREGATE_VIEW.val);
    //     }else{
    //         setSelectedTestTypeVal(REPORTS.CLASS_QUESTION_VIEW.val);
    //     }
    // }

    const handleTestChange = value =>{
        setTempTestIds(value);
    }

    useEffect(() => {
        if (tempTestIds.length === 0) {
            handleTestClear();
        }
        showCascadingFeedbackMessage();
    }, [tempTestIds]);

    const handleReportChange = value =>{
        if(REPORTS.ORDER_BY_AGGREGATE_VIEW.val === value){
            setAggregateDisabled(false);
        }else{
            setAggregateDisabled(true);
        }
        // // select both test assignments automatically for Comparison View
        if(value === REPORTS.COMPARISON_VIEW.val && selectedTestIds.length > 0) {
            const testIds = [];
            diagnosticTests.forEach(diagTest => {
                testIds.push(diagTest.testId);
            })
            setTempTestIds(testIds);
            classDiagnosticForm.setFieldsValue({['diagnosticTests']: testIds});
        }
        setSelectedTestTempTypeVal(value);
    }

    const generateReport = async () => {
        // setLoading(true);
        if (!classId || !topicId) {
            showCascadingFeedbackMessage();
            setLoading(false);
            return;
        }
        let testIds = [];
        // select both test assignments automatically for Comparison View
        if (selectedTestTempTypeVal === REPORTS.COMPARISON_VIEW.val && tempTestIds.length > 0) {
            diagnosticTests.forEach(diagTest => {
                testIds.push(diagTest.testId);
            })
            classDiagnosticForm.setFieldsValue({['diagnosticTests']: testIds});
            setSelectedTestIds(testIds);
            setTempTestIds(testIds);
        }else{
            setSelectedTestIds(tempTestIds);
            testIds = [...tempTestIds];
        }

        setSelectedTestTypeVal(selectedTestTempTypeVal);
        setReportTitle(calcReportTitle(selectedTestTempTypeVal));

        setTriggerGenerate(new Date().getTime());
        // setLoading(false);
    }

    const calcReportTitle = reportVal =>{
        if(reportVal === 1){
            return REPORTS.CLASS_QUESTION_VIEW.description;
        }else if(reportVal === 2){
            return REPORTS.ORDER_BY_AGGREGATE_VIEW.description;
        }else{
            return REPORTS.COMPARISON_VIEW.description;
        }
    }

    const handleTestClear = () => {
        setLoading(false);
        setSelectedTestIds([]);
        setTestAssignmentsData([]);
        setStudentTestAssignmentsMap({});
        setSelectedTestTypes([]);
        setEnabledStudentIdsMap({});
        setEnabledStudentIdsArr([]);
        setWarningFeedbackMessage(undefined);
        // setStudentIds(initialStudentIds);
        // diagnosticForm.setFieldsValue({['studentIds']:initialStudentIds});
    }

    const showCascadingFeedbackMessage = ()=> {
        let messageShown = false;
        if(!classId){
            setFeedbackMessage(FB_MESSAGES.SELECT_CLASS_TEST_MESSAGE);
            messageShown = true;
        }else if(!topicId){
            setFeedbackMessage(FB_MESSAGES.SELECT_TOPIC_TEST_MESSAGE);
            messageShown = true;
        }else if(tempTestIds.length === 0){
            setFeedbackMessage(FB_MESSAGES.SELECT_DIAGNOSTIC_TEST_MESSAGE);
            messageShown = true;
        }else if (students.length === 0) {
            setFeedbackMessage(FB_MESSAGES.NO_STUDENTS_IN_CLASS);
            messageShown = true;
        } else if (studentIds.length === 0) {
            setFeedbackMessage(FB_MESSAGES.SELECT_STUDENT_TEST_MESSAGE);
            messageShown = true;
        } else if (!reportGenerated) {
            setFeedbackMessage('No report generated.');
            messageShown = true;
        }
        return messageShown;
    }

    const handleReportClear = () =>{

    }

    const handleSyllabusSelect = (value, options) =>{
        clearTestSelect();
        handleTopicClear();
        setTextSyllabus(syllabusesMap[value])
        classDiagnosticForm.setFieldsValue({['topicId']:null});
        setSyllabusId(value);
        setTestAssignmentsData([]);
        setStudentTestAssignmentsMap({});
        setSelectedTestTypes([]);
    }

    const handleTopicSelect = (value, options) =>{
        clearTestSelect();
        setTopicId(value);
        setDiagnosticTests([]);
        setTestAssignmentsData([]);
        setStudentTestAssignmentsMap({});
        setSelectedTestTypes([]);
        setTempTestIds([]);
        showCascadingFeedbackMessage();
    }

    const handleTopicClear = () =>{
        clearTestSelect();
        setDiagnosticTests([]);
        setTestAssignmentsData([]);
        setStudentTestAssignmentsMap({});
        setSelectedTestTypes([]);
        setSelectedTestIds([]);
        setTempTestIds([]);
        setTopicId(null);
        setWarningFeedbackMessage(undefined);
    }

    const clearTestSelect = ()=>{
        classDiagnosticForm.resetFields(['diagnosticTests']);
        setSelectedTestIds([]);
        setSelectedTestTypes([]);
        setCurriculumValues([]);
        setTextValues([]);
    }

    useEffect(() => {
        if(user.syllabusGroupId){
            axios.get('/web/ui/nav/syllabusGroup/' + user.syllabusGroupId + '/syllabuses')
                .then(response => {
                    if(response.data){
                        setSyllabuses(response.data);
                    }
                    setIsMainLoading(false);
                }).catch(error=>{
                    setIsMainLoading(false);
                console.error('Error loading syllabus group. ',error);
            });
        }else{
            setIsMainLoading(false);
        }
    },[]);

    useEffect(()=>{
        if(!syllabusId){
            showCascadingFeedbackMessage();
            return;
        }
        axios.get('/web/ui/nav/syllabus/' + syllabusId + '/topics')
            .then(response => {
                if (response.data) {
                   setTopics(response.data);
                }
            }).catch(error=>{
                console.error('Error loading syllabus. ',error);
        });

        axios.get('/web/ui/nav/getSyllabusLink',{params: {syllabusId:syllabusId}})
            .then(response => {
                if(response.data){
                    setCurriculumSyllabus(response.data);
                }else{
                    setCurriculumSyllabus({});
                }
            }).catch(error=>{
            console.error('Error loading syllabus link. ',error);
        });

    },[syllabusId]);

    useEffect( ()=>{
        // also covers when undefined shows up
        if(topicId == null){
            showCascadingFeedbackMessage();
        }else{
            axios.get('/web/ui/test/diagnosticTests',{params: {topicId:topicId}})
                .then(response => {
                    if(response.data){
                        setDiagnosticTests(response.data);
                    }
            });

        }
    },[topicId]);

    useEffect(()=>{
        if(!classId  || !topicId){
            showCascadingFeedbackMessage();
            setLoading(false);
            return;
        }

        setHasStudentResults(false);
        setTestAssignmentsData([]);
        setStudentTestAssignmentsMap({});

        if (selectedTestIds.length > 0) {
            setLoading(true);
            setReportGenerated(true);
            axios.get('/web/ui/test/loadDiagnosticTestAssignmentResults', {
                params: {
                    testIds: selectedTestIds.toString(),
                    classId: classId,
                    skillQuestionResults: REPORTS.CLASS_QUESTION_VIEW.val !== selectedTestTypeVal
                }
            })
                .then(response => {
                    let studentAssignmentIdsMap = {},
                        resultsFeedbackMap = {},
                        diagnosticAssignments = [],
                        tempSelectedTestTypes = [],
                        studentDataCount = 0;

                    setLoading(false);

                    if (response.data) {
                        response.data.forEach(diagnosticTestData => {
                            for (const [key, value] of Object.entries(diagnosticTestData.studentTestAssignmentMap)) {
                                if (studentAssignmentIdsMap[key]) {
                                    studentAssignmentIdsMap[key] = {...studentAssignmentIdsMap[key], ...value};
                                } else {
                                    studentAssignmentIdsMap[key] = value;
                                }
                            }

                            tempSelectedTestTypes.push(diagnosticTestData.testGroupCode);
                            resultsFeedbackMap[diagnosticTestData.testGroupCode] = {
                                testType: TEST_TYPES[diagnosticTestData.testGroupCode],
                                mostRecentResult: diagnosticTestData.mostRecentResult,
                                hasQuestionResults: diagnosticTestData.hasQuestionResults,
                                testAssigned: diagnosticTestData.testAssignmentId !== undefined
                            }

                            if (diagnosticTestData.questionCount > questionCount) {
                                setQuestionCount(diagnosticTestData.questionCount);
                            }

                            if (diagnosticTestData.hasQuestionResults) {
                                studentDataCount++;
                            }

                            diagnosticAssignments.push(diagnosticTestData);
                        });
                    }
                    // console.log('studentDataCount', studentDataCount);
                    if (studentDataCount === 0) {
                        let message;
                        if (brandConfig.userAssignedDiagnostics) {
                            message = FB_MESSAGES.NO_STUDENT_RESULTS_DATA;

                            tempSelectedTestTypes.forEach(testGroupCode => {
                                if (message === FB_MESSAGES.NO_STUDENT_RESULTS_DATA) {
                                    message += TEST_TYPES[testGroupCode].description + (tempSelectedTestTypes.length === 1 ? '.' : '');
                                } else {
                                    message += ' and ' + TEST_TYPES[testGroupCode].description + '.';
                                }
                            });
                        } else {
                            if (Object.entries(studentAssignmentIdsMap).length > 0) {
                                message = FB_MESSAGES.NO_STUDENT_RESULTS_DATA_NO_TEST;
                            } else {
                                message = FB_MESSAGES.TESTS_NOT_ASSIGNED;
                            }

                            if (tempSelectedTestTypes.length == 1) {
                                if (Object.entries(studentAssignmentIdsMap).length > 0) {
                                    message = FB_MESSAGES.NO_STUDENT_RESULTS_DATA + TEST_TYPES[tempSelectedTestTypes[0]].description + '.'
                                } else {
                                    message = FB_MESSAGES[TEST_TYPES[tempSelectedTestTypes[0]].code + '_NOT_ASSIGNED'];
                                }
                            }
                        }
                        setWarningFeedbackMessage(undefined);
                        setFeedbackMessage(message);
                    } else {
                        let message;
                        if (Object.values(resultsFeedbackMap).length === 1) {
                            let testFeedback = Object.values(resultsFeedbackMap)[0];
                            if (testFeedback.mostRecentResult && testFeedback.hasQuestionResults) {
                                message = FB_MESSAGES.MOST_RECENT_ONLY + testFeedback.testType.description + '.';
                            } else if (!testFeedback.hasQuestionResults && (brandConfig.userAssignedDiagnostics || testFeedback.testAssigned)) {
                                message = FB_MESSAGES.NO_STUDENT_RESULTS_DATA + testFeedback.testType.description + '.';
                            } else if (!testFeedback.testAssigned) {
                                message = FB_MESSAGES[testFeedback.testType.code + '_NOT_ASSIGNED'];
                            }
                        } else if (Object.values(resultsFeedbackMap).length === 2) {
                            let preTestFeedback = resultsFeedbackMap["DIAGNOSTIC_PRE_TEST"],
                                postTestFeedback = resultsFeedbackMap["DIAGNOSTIC_POST_TEST"];
                            if (preTestFeedback.mostRecentResult && preTestFeedback.hasQuestionResults) {
                                message = FB_MESSAGES.MOST_RECENT_ONLY + preTestFeedback.testType.description;
                                if (postTestFeedback.mostRecentResult && postTestFeedback.hasQuestionResults) {
                                    message += ' and ' + postTestFeedback.testType.description + '.';
                                } else if (brandConfig.userAssignedDiagnostics || postTestFeedback.testAssigned) {
                                    message += '.\n' + FB_MESSAGES.NO_STUDENT_RESULTS_DATA + postTestFeedback.testType.description + '.';
                                } else if (postTestFeedback.testAssigned) {
                                    message += '.\n' + FB_MESSAGES.POST_TEST_NOT_ASSIGNED;
                                }
                            } else if (brandConfig.userAssignedDiagnostics || preTestFeedback.testAssigned) {
                                message = FB_MESSAGES.NO_STUDENT_RESULTS_DATA + preTestFeedback.testType.description;
                                if (postTestFeedback.mostRecentResult && postTestFeedback.hasQuestionResults) {
                                    message += '.\n' + FB_MESSAGES.MOST_RECENT_ONLY + postTestFeedback.testType.description + '.';
                                } else if (brandConfig.userAssignedDiagnostics || postTestFeedback.testAssigned) {
                                    message += ' and ' + postTestFeedback.testType.description + '.';
                                } else if (postTestFeedback.testAssigned) {
                                    message += '.\n' + FB_MESSAGES.POST_TEST_NOT_ASSIGNED;
                                }
                            } else if (!preTestFeedback.testAssigned) {
                                message = FB_MESSAGES.PRE_TEST_NOT_ASSIGNED;
                                if (postTestFeedback.mostRecentResult && postTestFeedback.hasQuestionResults) {
                                    message += '.\n' + FB_MESSAGES.MOST_RECENT_ONLY + postTestFeedback.testType.description + '.';
                                } else if (brandConfig.userAssignedDiagnostics || postTestFeedback.testAssigned) {
                                    message += '.\n' + FB_MESSAGES.NO_STUDENT_RESULTS_DATA + postTestFeedback.testType.description + '.';
                                } else if (postTestFeedback.testAssigned) {
                                    message = FB_MESSAGES.TESTS_NOT_ASSIGNED;
                                }
                            } else {
                                if (postTestFeedback.mostRecentResult && postTestFeedback.hasQuestionResults) {
                                    message = FB_MESSAGES.MOST_RECENT_ONLY + postTestFeedback.testType.description + '.';
                                } else if (brandConfig.userAssignedDiagnostics || postTestFeedback.testAssigned) {
                                    message = FB_MESSAGES.NO_STUDENT_RESULTS_DATA + postTestFeedback.testType.description + '.';
                                } else if (!postTestFeedback.testAssigned) {
                                    message = FB_MESSAGES[postTestFeedback.testType.code + '_NOT_ASSIGNED'];
                                }
                            }

                            if (message !== undefined && message.charAt(message.length - 1) !== '.') {
                                message += '.';
                            }
                        }

                        setFeedbackMessage(message);
                    }

                    setStudentTestAssignmentsMap(studentAssignmentIdsMap);
                    setSelectedTestTypes(tempSelectedTestTypes);
                    setTestAssignmentsData(diagnosticAssignments);
                    setHasStudentResults(studentDataCount > 0);
                }).catch(event=>{
                    console.error('Error loading assigned diagnostic tests: ',event);
                    setLoading(false);
                });
        }
    },[selectedTestIds, triggerGenerate]);

    const toggleTrendLines = value =>{
        setShowTrendLines(value);
    }

    const toggleAverageLine = value =>{
        setShowAverageLine(value);
    }

    const handleComparisonContent = e =>{
        setComparisonContentTypeVal(e.target.value);
        setCurriculumValues([]);
        setTextValues([]);
    }

    /* sticky header */
    const fixedTableHeaderScroll = (e,tableView) =>{
        const diagnosticReportsEl = document.getElementById('diagnosticReports');

        if(diagnosticReportsEl === undefined){
            return;
        }

        const root = diagnosticReportsEl.getElementsByClassName('ag-root');

        if (root === undefined) {
            return;
        }

        const tablePosition = tableView.getBoundingClientRect().top+window.scrollY+GridStyle.VERTICAL_HEADER_OFFSET,
            parentWidth = root.clientWidth,
            leftHeaderWidth = diagnosticReportsEl.getElementsByClassName('ag-pinned-left-header')[0].clientWidth,
            viewPort = diagnosticReportsEl.getElementsByClassName('ag-header-viewport')[0],
            headerElem = diagnosticReportsEl.getElementsByClassName('ag-header')[0],
            rightHeaderElem = diagnosticReportsEl.getElementsByClassName('ag-header-row-column')[0],
            scrollMask = diagnosticReportsEl.getElementsByClassName('grid-fixed-mask')[0];

        if(Math.round(tablePosition) < 0){
            // header fixed
            setHeaderHeightOffset(GridStyle.VERTICAL_HEADER_HEIGHT);
            headerElem.classList.add("fixed-ag-header");
            rightHeaderElem.classList.add("fixed-ag-header-right");
            scrollMask.classList.add("show");
        }else{
            // header unset
            setHeaderHeightOffset(0);
            headerElem.classList.remove("fixed-ag-header");
            rightHeaderElem.classList.remove("fixed-ag-header-right");
            scrollMask.classList.remove("show");
        }
        viewPort.style.width = (parentWidth-leftHeaderWidth)+"px";
        headerElem.style.width = (parentWidth)+"px";
        scrollMask.style.width = (parentWidth + 2)+"px";
    }

    useEffect(() => {
        const tableView = document.getElementById('graphView');

        if(tableView) {
            document.getElementById('content').addEventListener("scroll",e=>{
                fixedTableHeaderScroll(e,tableView);
            });
            // console.log('add resize listener');
            window.addEventListener('resize', e=>{
                fixedTableHeaderScroll(e,tableView);
            });

            return () => {
                document.getElementById('content').removeEventListener("scroll",fixedTableHeaderScroll);
                window.removeEventListener("resize",fixedTableHeaderScroll);
            }
        }
    }, []);


    useEffect(()=>{
        const tableView = document.getElementById('graphView');
        if(tableView){
            for(let i = 1; i <= 50; i++){
                setTimeout(()=>{
                    fixedTableHeaderScroll(null,tableView);
                },i*10);
            }
        }
    },[menuPosition.rightMenuClosed, menuPosition.leftMenuClosed]);

    /* sticky header end*/
    return (
        <>
        {isMainLoading && <CircularLoader/>}
        {!isMainLoading &&
            <div id={"diagnosticReports"}>
                <div className={'grid-fixed-mask'}>
                    <div className={'top-mask'}></div>
                    <div className={'border-mask'}></div>
                </div>
                    <div className={"reportsFormWrapper"}>
                        <Form
                                name="contentSearchForm"
                                form={diagnosticForm}
                                autoComplete="off"
                                initialValues={{classId:classId, studentIds:initialStudentIds, diagnosticTests:[]}}
                                // onFinish={handleSearch}
                                layout="vertical"
                            >
                                <Row gutter={24}>
                                    <Col span={10}>
                                        <Form.Item
                                            label="Class"
                                            name="classId"
                                        >
                                            <Select virtual={false} allowClear autoClearSearchValue={true} onSelect={handleClassSelect} onClear={handleClassClear} getPopupContainer={trigger => trigger.parentElement} >
                                                {user.classes.map((clazz) => {
                                                    return <Option key={clazz.classId} value={clazz.classId}>{clazz.className}</Option>;
                                                })}
                                            </Select>

                                        </Form.Item>
                                    </Col>
                                    <Col span={10}>
                                        <Form.Item
                                            label="Student"
                                            name="studentIds"
                                        >
                                            <Select virtual={false} showSearch={false} showarrow={"true"} popupRender={menu => (
                                                <div>
                                                    {menu}
                                                    <Divider style={{ margin: '0 0 4px 0' }} />
                                                    <div style={{ padding: '4px'}}>
                                                        <Checkbox disabled={initialStudentIds.length === 0} value={studentIds} defaultChecked={true} checked={studentIds.length === initialStudentIds.length} onChange={handleSelectAllChange}>Select all students</Checkbox>
                                                    </div>
                                                </div>
                                            )}
                                                    allowClear autoClearSearchValue={true}
                                                    // onSelect={handleStudentSelect} onDeselect={handleStudentDeselect}
                                                    onChange={handleStudentChange}
                                                    // onClear={handleStudentClear}
                                                    mode="multiple" maxTagCount="responsive"
                                                    getPopupContainer={trigger => trigger.parentElement} >
                                                {students.map((student) => {
                                                    return <Option disabled={enabledStudentIdsMap.hasOwnProperty(student.userId) ? enabledStudentIdsMap[student.userId].disabled : false } key={student.userId} value={student.userId}>{student.lastName+', '+student.firstName}</Option>;
                                                })}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </Row>
                        </Form>
                        <Form
                            name="classDiagnostic"
                            form={classDiagnosticForm}
                            initialValues={{ syllabusGroupId: user.syllabusGroupId, syllabusId: syllabusId, topicId: topicId, reportViewVal:REPORTS.CLASS_QUESTION_VIEW.val}}
                            autoComplete="off"
                            labelCol={{ span: 3 }}
                            // wrapperCol={{ span: 12 }}
                        >
                            <Row align={"bottom"}>
                                <Col span={16} >
                                    <h5 style={{marginTop:'8px'}}>Content</h5>
                                    <Space direction="vertical">
                                        <Form.Item
                                            label="Report"
                                            name="reportViewVal">
                                            <Select
                                                onClear={handleReportClear}
                                                onChange={handleReportChange}
                                                getPopupContainer={trigger => trigger.parentElement}
                                            >
                                                <Option key={REPORTS.CLASS_QUESTION_VIEW.val} value={REPORTS.CLASS_QUESTION_VIEW.val}>{REPORTS.CLASS_QUESTION_VIEW.description}</Option>
                                                <Option key={REPORTS.ORDER_BY_AGGREGATE_VIEW.val} value={REPORTS.ORDER_BY_AGGREGATE_VIEW.val}>{REPORTS.ORDER_BY_AGGREGATE_VIEW.description}</Option>
                                                <Option key={REPORTS.COMPARISON_VIEW.val} value={REPORTS.COMPARISON_VIEW.val}>{REPORTS.COMPARISON_VIEW.description}</Option>
                                            </Select>
                                        </Form.Item>
                                        <Form.Item
                                            label={syllabusLabel}
                                            name="syllabusId"
                                        >
                                            <Select onSelect={(value,options)=>handleSyllabusSelect(value, options)} getPopupContainer={trigger => trigger.parentElement}>
                                                {syllabuses.map((syllabus) => {
                                                    return <Option key={syllabus.syllabusId} value={syllabus.syllabusId}>{syllabus.syllabusName}</Option>;
                                                })}
                                            </Select>
                                        </Form.Item>
                                        <Form.Item
                                            label={topicLabel}
                                            name="topicId"
                                        >
                                            <Select allowClear onSelect={(value,options)=>handleTopicSelect(value, options)} onClear={handleTopicClear} getPopupContainer={trigger => trigger.parentElement}>
                                                {topics.map((topic) => {
                                                    return <Option key={topic.topicId} value={topic.topicId}>{topic.topicName}</Option>;
                                                })}
                                            </Select>
                                        </Form.Item>
                                        <Form.Item
                                            label="Test"
                                            name="diagnosticTests">
                                            <Select
                                                mode="multiple"
                                                showSearch={false}
                                                showarrow={"true"}
                                                allowClear
                                                onClear={handleTestClear}
                                                autoClearSearchValue={true}
                                                onChange={handleTestChange}
                                                // onBlur={handleTestBlur}
                                                removeIcon={null}
                                                getPopupContainer={trigger => trigger.parentElement}
                                            >
                                                {diagnosticTests.map((diagnosticTest) => {
                                                    return <Option key={diagnosticTest.testId} value={diagnosticTest.testId}>{diagnosticTest.name}</Option>;
                                                })}
                                            </Select>
                                        </Form.Item>
                                    </Space>
                                </Col>
                                <Col>
                                    <Form.Item name="generate">
                                        <Button size={'medium'}
                                                disabled={tempTestIds.length === 0 || studentIds.length === 0}
                                                onClick={generateReport}>Generate</Button>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                        <Form className="inlineForm"
                              name="classDiagnosticFilterForm"
                              form={classDiagnosticFilterForm}
                              layout="vertical"
                              size="small"
                              initialValues={{ comparisonContent: COMPARISON_TYPE.TEXT.val, columnOrderBy: GRID_ENUMS.NAME_ASC,contentType: contentType, aggregateGroupBy:AGGREGATE_LEVELS.SKILL}}
                              autoComplete="off"
                              style={{
                                  borderBottom:'1px solid lightgrey'
                              }}
                        >
                            <Row>
                                <Col span={6}>
                                    <h5>Filter</h5>
                                    <Form.Item
                                        label="Difficulty"
                                        name="difficulty"
                                        style={{width: '95%'}}
                                    >
                                        <Select showSearch={false}  showarrow={"true"} allowClear mode="multiple" onChange={handleDifficultyChange} getPopupContainer={trigger => trigger.parentElement}>
                                            {brandConfig.testLevels.map((level) => {
                                                return <Option key={level} value={level}>{level}</Option>
                                            })}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                {selectedTestTypeVal === REPORTS.COMPARISON_VIEW.val &&
                                    <Col span={5}>
                                        <h5>Comparison view
                                            <Tooltip title={COMPARISON_VIEW_TOOLTIP}
                                                                    // placement="bottom"
                                                                   arrowPointAtCenter>
                                            <HelpIcon style={{
                                                verticalAlign: 'middle',
                                                marginLeft: '4px',
                                                width: '16px',
                                                height: '16px'
                                            }}/>
                                        </Tooltip>
                                        </h5>
                                        <Form.Item
                                            label="Content type"
                                            name="comparisonContent"
                                            style={{width: '95%'}}
                                        >
                                            <Radio.Group onChange={handleComparisonContent} >
                                                <Radio.Button value={COMPARISON_TYPE.TEXT.val}>Text</Radio.Button>
                                                <Radio.Button disabled={curriculumDisabled} value={COMPARISON_TYPE.CURRICULUM.val}>Curriculum</Radio.Button>
                                            </Radio.Group>
                                        </Form.Item>
                                    </Col>
                                }
                                {selectedTestTypeVal === REPORTS.COMPARISON_VIEW.val &&
                                    <Col span={12}>
                                        <Row>
                                            <Col span={8}>
                                                <Form.Item className="toggleSwitch" label="Trend lines" tooltip={{title:'Trend lines tooltip'}}>
                                                    <Switch
                                                        defaultChecked={true}
                                                        onChange={toggleTrendLines}
                                                        color="primary"
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={8}>
                                                <Form.Item className="toggleSwitch" label="Average line" tooltip={{title:'Average line tooltip'}}>
                                                    <Switch
                                                        defaultChecked={true}
                                                        onChange={toggleAverageLine}
                                                        color="primary"
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col span={24}>
                                                {comparisonContentTypeVal === COMPARISON_TYPE.CURRICULUM.val &&
                                                    <Form.Item
                                                        label="Curriculum"
                                                        name="curriculumSelect"
                                                        style={{width: '95%', gap:'10px'}}
                                                    >
                                                        <TreeSelectFilter syllabus={curriculumSyllabus} setValues={setCurriculumValues} testIds={selectedTestIds} comparisonContentTypeVal={comparisonContentTypeVal} />
                                                    </Form.Item>
                                                }
                                                {comparisonContentTypeVal === COMPARISON_TYPE.TEXT.val &&
                                                    <Form.Item
                                                        label="Text"
                                                        name="textSelect"
                                                        style={{width: '95%', gap:'10px'}}
                                                    >
                                                        <TreeSelectFilter syllabus={textSyllabus} setValues={setTextValues} testIds={selectedTestIds} comparisonContentTypeVal={comparisonContentTypeVal} />
                                                    </Form.Item>
                                                }
                                            </Col>
                                        </Row>

                                    </Col>
                                }
                                {(selectedTestTypeVal === REPORTS.CLASS_QUESTION_VIEW.val || selectedTestTypeVal === REPORTS.ORDER_BY_AGGREGATE_VIEW.val) &&
                                    <Col span={6}>
                                        <h5>Order by</h5>
                                        <Form.Item
                                            label="Student"
                                            name="columnOrderBy"
                                            style={{width: '95%'}}
                                        >
                                            <Select onChange={handleStudentColOrderByChange} getPopupContainer={trigger => trigger.parentElement}>
                                                <Option key={GRID_ENUMS.NAME_ASC} value={GRID_ENUMS.NAME_ASC}>first name ascending</Option>
                                                <Option key={GRID_ENUMS.NAME_DESC} value={GRID_ENUMS.NAME_DESC}>first name descending</Option>
                                                <Option key={GRID_ENUMS.LOWEST} value={GRID_ENUMS.LOWEST}>lowest performance</Option>
                                                <Option key={GRID_ENUMS.HIGHEST} value={GRID_ENUMS.HIGHEST}>highest performance</Option>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                }
                                {(selectedTestTypeVal === REPORTS.ORDER_BY_AGGREGATE_VIEW.val
                                    // || selectedTestTypeVal === REPORTS.CLASS_QUESTION_VIEW.val
                                ) &&
                                    <Col span={10} style={{marginLeft: '4px'}} id="aggregateFields">
                                        <h5>Aggregate view<Tooltip title={AGGREGATE_VIEW_TOOLTIP}
                                            // placement="bottom"
                                                                   arrowPointAtCenter>
                                            <HelpIcon style={{
                                                verticalAlign: 'middle',
                                                marginLeft: '4px',
                                                width: '16px',
                                                height: '16px'
                                            }}/>
                                        </Tooltip></h5>
                                        <Form.Item name="contentType" label="Course type"
                                                   // tooltip={{title:'Filter by course type'}}
                                        >
                                            <Radio.Group onChange={handleContentTypeChange} disabled={aggregateDisabled}>
                                                <Radio.Button value={GRID_ENUMS.TEXT}>Text</Radio.Button>
                                                <Radio.Button disabled={curriculumDisabled} value={GRID_ENUMS.CURRICULUM}>Curriculum</Radio.Button>
                                            </Radio.Group>
                                        </Form.Item>
                                        <Form.Item
                                            label="Group by"
                                            name="aggregateGroupBy"
                                            style={{marginLeft:'8px'}}
                                        >
                                            <Select onChange={handleAggregateLevelChange} disabled={aggregateDisabled} style={{minWidth:'100px'}} getPopupContainer={trigger => trigger.parentElement}>
                                                <Option key={AGGREGATE_LEVELS.SKILL}
                                                        value={AGGREGATE_LEVELS.SKILL}>Skill</Option>
                                                <Option key={AGGREGATE_LEVELS.CONCEPT}
                                                        value={AGGREGATE_LEVELS.CONCEPT}>Topic</Option>
                                                <Option key={AGGREGATE_LEVELS.TOPIC}
                                                        value={AGGREGATE_LEVELS.TOPIC}>Chapter</Option>
                                                <Option key={AGGREGATE_LEVELS.SYLLABUS}
                                                        value={AGGREGATE_LEVELS.SYLLABUS}>Course</Option>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                }
                            </Row>
                        </Form>
                    </div>

                    <div id="graphView">
                        <CircularLoader displayInElement={true} pageCentered={true} visible={isLoading} />
                        {!isLoading &&
                            <>
                                {feedbackMessage !== undefined &&
                                    <p className={'ch-dashboard-warning-text'}>{feedbackMessage}</p>}
                                {warningFeedbackMessage !== undefined && studentIds.length > 0 &&
                                    <p className={'ch-dashboard-warning-text'}>{warningFeedbackMessage}</p>}
                                {selectedTestTypes.length > 0 && selectedTestIds.length > 0 && studentIds.length > 0 && hasStudentResults &&
                                    <div>
                                        {selectedTestTypeVal === REPORTS.CLASS_QUESTION_VIEW.val &&
                                            <>
                                                <h3>{reportTitle}</h3>
                                                <ClassQuestionViewDiagnostic
                                                    isDiagnostic={true}
                                                    testAssignmentsData={testAssignmentsData}
                                                    studentTestAssignmentsMap={studentTestAssignmentsMap}
                                                    questionCount={questionCount}
                                                    students={students}
                                                    studentIds={studentIds}
                                                    classId={classId}
                                                    className={className}
                                                    studentColOrder={studentColOrder}
                                                    selectedDifficultyIds={selectedDifficultyIds}
                                                    selectedTestIds={selectedTestIds}
                                                    contentType={contentType}
                                                    isLoading={isLoading}
                                                    setLoading={setLoading}
                                                    headerHeightOffset={headerHeightOffset}
                                                    openDialogCallback={openStudentTestsDialog}
                                                    triggerGenerate={triggerGenerate}
                                                />
                                            </>
                                        }
                                        {selectedTestTypeVal === REPORTS.ORDER_BY_AGGREGATE_VIEW.val &&
                                            <>
                                                <h3>{reportTitle}</h3>
                                                <GroupByAggregateView
                                                    isDiagnostic={true}
                                                    testAssignmentsData={testAssignmentsData}
                                                    studentTestAssignmentsMap={studentTestAssignmentsMap}
                                                    students={students}
                                                    studentIds={studentIds}
                                                    classId={classId}
                                                    className={className}
                                                    studentColOrder={studentColOrder}
                                                    selectedAggregateLevel={selectedAggregateLevel}
                                                    selectedDifficultyIds={selectedDifficultyIds}
                                                    selectedTestIds={selectedTestIds}
                                                    contentType={contentType}
                                                    isLoading={isLoading}
                                                    setLoading={setLoading}
                                                    selectedTestTypes={selectedTestTypes}
                                                    headerHeightOffset={headerHeightOffset}
                                                    openDialogCallback={openStudentTestsDialog}
                                                    triggerGenerate={triggerGenerate}
                                                />
                                            </>
                                        }
                                        {selectedTestTypeVal === REPORTS.COMPARISON_VIEW.val &&
                                            <>
                                                <h3>{reportTitle}</h3>
                                                <ComparisonView
                                                    testAssignmentsData={testAssignmentsData}
                                                    students={students}
                                                    studentIds={studentIds}
                                                    classId={classId}
                                                    selectedDifficultyIds={selectedDifficultyIds}
                                                    selectedTestIds={selectedTestIds}
                                                    isLoading={isLoading}
                                                    setLoading={setLoading}
                                                    showTrendLines={showTrendLines}
                                                    showAverageLine={showAverageLine}
                                                    comparisonContentTypeVal={comparisonContentTypeVal}
                                                    curriculumValues={curriculumValues}
                                                    textValues={textValues}
                                                    openDialogCallback={openStudentTestsDialog}
                                                    triggerGenerate={triggerGenerate}
                                                />
                                            </>
                                        }
                                        <StudentTestResultDialog open={studentTestResultDialogOpen} testAssignmentIds={testAssignmentIds} studentId={studentId} studentTestAssignmentsMap={studentTestAssignmentsMap} handleClose={handleCloseStudentTestsDialog} />
                                    </div>
                                }
                            </>
                        }
                    </div>
            </div>
        }
        </>
        );
}
export default DiagnosticReports;
